import Meta from '../components/common/Meta';
import RedesignPageLayout from '../components/common/RedesignPageLayout';
import BlogRequestAdd from '../components/blog-request/BlogRequestAdd';

const meta = {
    title: '提交博客 - 博客中心',
    keywords: '提交博客',
    description: '提交博客。',
};

export default function BlogRequestAddPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <div className="redesign-submit-wrap">
                    <header className="redesign-page-header">
                        <h1 className="redesign-page-title">提交博客</h1>
                        <p className="redesign-page-desc">
                            填写以下信息申请博客收录，审核结果将在 24 小时内邮件通知。
                        </p>
                    </header>

                    <div className="redesign-submit-stage">
                        <img
                            className="redesign-submit-illustration"
                            src="/assets/images/sites/redesign/submit-bg.png"
                            alt=""
                            aria-hidden="true"
                        />
                        <div className="redesign-submit-form">
                            <BlogRequestAdd />
                        </div>
                    </div>
                </div>
            </RedesignPageLayout>
        </>
    );
}
